<template>
  <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
    <a-form-item label="中奖时间" name='time'>
      <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="onChange" v-model:value="time"
        style="width:360px" />
    </a-form-item>
    <a-form-item label="中奖状态" name='is_award'>
      <a-select style="width: 120px" placeholder="请选择" v-model:value="search.is_award" @change="changIsAward">
        <a-select-option value=''>全部</a-select-option>
        <a-select-option :value='0'>未中奖</a-select-option>
        <a-select-option :value='1'>已中奖</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="会员信息" name='member_info'>
      <a-input placeholder="请输入昵称/ID进行搜索" style='width:220px' v-model:value="search.member_info" />
    </a-form-item>
    <a-form-item label="码ID" name='code'>
      <a-input placeholder="请输入码ID" style='width:220px' v-model:value="search.code" />
    </a-form-item>
    <a-form-item label="发放奖品" name='sward_mode' class="m-t-10">
      <a-input-group compact :style="{width:'360px'}">
        <a-select style="width: 30%" v-model:value="search.sward_mode">
          <a-select-option value=''>全部</a-select-option>
          <a-select-option :value='1'>积分</a-select-option>
          <a-select-option :value='2'>礼品</a-select-option>
          <a-select-option :value='3'>红包</a-select-option>
          <a-select-option :value='4'>优惠券</a-select-option>
          <a-select-option :value='5'>附加奖</a-select-option>
        </a-select>
        <a-input style="width: 70%" v-model:value="search.award_content" placeholder="请输入关键词进行搜索" />
      </a-input-group>
    </a-form-item>
    <a-form-item label="发放状态" name='award_status' class="m-t-10">
      <a-select style="width: 120px" placeholder="请选择" v-model:value="search.award_status">
        <a-select-option value=''>全部</a-select-option>
        <a-select-option :value='4'>待领取</a-select-option>
        <a-select-option :value='0'>待发放</a-select-option>
        <a-select-option :value='3'>已发放</a-select-option>
        <a-select-option :value='1'>发放成功</a-select-option>
        <a-select-option :value='2'>发放失败</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item ref="" label="奖项名称" name="" class="m-t-10">
      <a-input v-model:value="search.award_name" style='width:220px' placeholder="请输入奖项名称"></a-input>
    </a-form-item>
    <a-form-item label="批次" name='batch_sn' class="m-t-10">
      <a-input v-model:value="search.batch_sn" style='width:220px' placeholder="请输入批次号进行搜索"></a-input>
    </a-form-item>
    <a-form-item label="所在地区" name='name' class="m-t-10">
      <selectCity v-model:value="search.name" placeholder="选择所在地区" v-on:citychange='citychange' style='width:300px' />
    </a-form-item>
    <a-form-item label="码类型" name='label_type' class="m-t-10">
      <a-select style="width: 120px" placeholder="请选择" v-model:value="search.label_type">
        <a-select-option value=''>全部</a-select-option>
        <a-select-option :value='2'>中箱码</a-select-option>
        <a-select-option :value='1'>箱码</a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="流水号" name='serial_sn' class="m-t-10">
      <a-input placeholder="请输入流水号进行搜索" style='width:220px' v-model:value="search.serial_sn" />
    </a-form-item>
    <a-form-item label="活动" name="" class="m-t-10">
      <a-input readonly placeholder="请选择活动" style='width:200px' v-model:value="search.activity_name"></a-input>
      <CloseCircleFilled class="fz-14 s_c999" style="position: absolute;right: 5px;top: 14px;" v-if='search.activity_name'  @click='search.activity_name="";search.activity_id=""' />
    </a-form-item>
    <a-form-item class="m-t-10">
      <a-button @click='()=>activityVisible=true' type="primary">选择</a-button>
    </a-form-item>
    <a-form-item class="m-t-10">
      <a-button type="primary" htmlType='submit'>搜索</a-button>
      <a-button v-has:marketingActivityAwardExport="exportTable" class='m-l-10' type="primary" ghost>导出</a-button>
      <a-button class='m-l-10' type="primary" ghost @click="viewVisble=true">查看生成报表</a-button>
    </a-form-item>
  </a-form>
  <div class='m-t-20'>
    <div class="s_flex_ali m-b-20">
      <div class="m-r-30 s_cd41">
        <span class="label s_c666">领奖人数：</span><span>{{totalData.member}}</span>
      </div>
      <div class="m-r-30 s_cd41">
        <span class="label s_c666">积分发放总量：</span><span>{{totalData.point}}</span>
      </div>
      <div class="m-r-30 s_cd41">
        <span class="label s_c666">红包发放总额：</span><span>{{totalData.bonus}}元</span>
      </div>
    </div>
    <a-table :pagination='false' rowKey="id" :loading='listLoading' bordered :columns='columns' :data-source='list'
      :scroll="{ x: 'max-content'}" class="tableFixBox">
      <template v-slot:member="{ record }">

        <div class="s_flex_ali" v-if="record.member_id!=0">
          <img class="width-50 height-50 m-r-15" :src="record.member_img ? record.member_img : ''" alt="" />
          <div>
            <p>{{record.member_name || '-'}}</p>
            <p>ID：{{record.member_id}}</p>
          </div>
        </div>
        <div v-else>
          <img class="width-50 height-50 m-r-15" src="@/assets/images/normal.png" alt="">
        </div>
      </template>
      <template v-slot:position="{record}">
        <p>{{record.city}}</p>
        <p>{{record.area}}</p>
      </template>
      <template v-slot:award_content_arr="{ record }">
        <div v-if='record.award_content_arr.length'>
          <p v-for="(item,index) in record.award_content_arr" :key='index' style="max-width:400px">{{item}}</p>
        </div>
        <p v-else>-</p>
      </template>
      <template v-slot:action="{ record }">
        <a href="javascript:;" v-has:marketingActivityAwardDetail="()=>{showMore = true;scan_id = record.id}">查看详情</a>
      </template>
    </a-table>
    <a-pagination :show-total="total => `总数:${total} `" :style="{marginTop:'10px',textAlign:'right'}" show-size-changer
      show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
      @showSizeChange="pageSizeChange" />
  </div>
  <!-- 活动弹窗 -->
  <a-modal v-model:visible="activityVisible" centered style="width:700px" :width='1000' :footer="null">
    <selectActivity v-on:select="activitySelect" :checkout='false' />
  </a-modal>
  <!-- 商品弹窗 -->
  <a-modal :keyboard="false" v-model:visible="productVisible" centered :footer="null" style="width:700px" :width='1000'>
    <selectGood v-on:select="goodSelect" :selectList='[{id:search.product_id}]'></selectGood>
  </a-modal>
  <a-modal :keyboard="false" title="扫码明细详情" centered v-model:visible="showMore" :width='1200' :footer="null"
    destroyOnClose>
    <scanMore type='activity' :id='scan_id'></scanMore>
  </a-modal>

  <!-- 报表 -->
  <a-modal :keyboard="false" title="查看报表" v-model:visible="viewVisble" centered :footer="null" :width='1000'
    destroyOnClose>
    <warehousTable :searchType="6" :exportType="2"></warehousTable>
  </a-modal>
</template>
<script>
  import {CloseCircleFilled } from "@ant-design/icons-vue";
  import { reactive, ref, toRefs, onMounted, inject } from "vue";
  import { iscode } from "@/utils/app";
  import { getAwardList, awardLogsExport, getAwardCount } from "@/api/qrcodeActivitys";
  import scanMore from './scanDetail.vue'
  import { message } from 'ant-design-vue';
  import { useTime } from '@/hooks/utils/useTime'
  const def = {
    page: 1,
    page_num: 10,
    sward_mode: '',
    activity_id: "",
    activity_name: "",
    award_status: "",
    is_award: "",
    batch_sn: "",
    fwcode_sn: "",
    code_sn: "",
    member_info: "",
    product_id: "",
    province_id: "",
    city_id: "",
    name: [],
    award_content: "",
    award_name: "",
    district_id: "",
    end_time: "",
    start_time: "",
    show_label_type:2,
    label_type:""
  };
  export default {
    name: "award",
    components: { scanMore,CloseCircleFilled },
    setup() {
      const state = reactive({
        vipList: [],
        listLoading: false,
        total: 0,
        visible: false,
        time: [],
        totalData: {},
        scan_id: '',
        showMore: false,
        viewVisble: false
      });
      let list = ref();

      let columns = [
        {
          title: "活动名称",
          dataIndex: "activity_name",
          key: "activity_name",
        },
        {
          title: "会员信息",
          dataIndex: "member",
          key: "member",
          slots: { customRender: "member" },
        },
        {
          title: "流水号",
          dataIndex: "code_sn",
          key: "code_sn",
        },
        // {
        //   title: "中奖信息",
        //   dataIndex: "is_award_title",
        //   key: "is_award_title",
        // },
        {
          title: "奖项名称",
          dataIndex: "award_name",
          key: "award_name",
          customRender: ({ record }) => {
            return record.award_name ? record.award_name : '-'
          }
        },
        {
          title: "奖项内容",
          dataIndex: "award_content_arr",
          key: "award_content_arr",
          slots: { customRender: "award_content_arr" },
        },
        {
          title: "开奖类型",
          dataIndex: "open_award_type",
          key: "open_award_type",
        },
        {
          title: "中奖时间",
          dataIndex: "created_time",
          key: "created_time",
        },
        {
          title: "发放状态",
          dataIndex: "award_status_title",
          key: "award_status_title",
        },
        {
          title: "扫码地区",
          dataIndex: "area",
          key: "area",
          slots: { customRender: "position" },
        },
        {
          title: "操作",
          key: "action",
          width: 100,
          fixed: "right",
          slots: { customRender: "action" },
        },
      ];
      const initData = async (values) => {
        state.listLoading = true;
        list.value = []
        let res = await getAwardList(values).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          list.value = res.data;
          state.total = res.meta.total;
        }
        state.listLoading = false;


        // 获取领奖人数量等..
        let result = await getAwardCount(values).then(res => res.data)
        state.totalData = result.data.total

      };
      const search = ref({ ...def });
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      const $moment = inject('momentTime')
      const { typeToStartEnd } = useTime();
      onMounted(() => {
        var end_time = $moment()
          .subtract(0, "d")
          .format("YYYY-MM-DD");
        var start_time = $moment()
          .subtract(29, "d")
          .format("YYYY-MM-DD");
        state.time = [start_time, end_time]
        search.value.start_time = start_time
        search.value.end_time = end_time
        initData(search.value);
      });
      const $router = inject("$router");
      //时间筛选
      const onChange = (e) => {
        if (!e) {
          search.value.start_time = "";
          search.value.end_time = "";
          return
        }
        search.value.start_time = e[0];
        search.value.end_time = e[1];
      };
      // 活动弹窗
      const activityVisible = ref(false);
      const activitySelect = (data) => {
        search.value.activity_id = data.activity_id;
        search.value.activity_name = data.activity_name;
        activityVisible.value = false;
      };
      // 商品弹窗
      const productVisible = ref(false);
      const goodSelect = (data) => {
        search.value.product_name = data.product_name;
        search.value.product_id = data.id;
        productVisible.value = false;
      };
      // 选择省市区
      const citychange = (e) => {
        search.value.province_id = e[0] || "";
        search.value.city_id = e[1] || "";
        search.value.district_id = e[2] || "";
      };
      // 切换是否中奖
      const changIsAward = (e) => {
        if (e == 0) {
          search.value.award_status = ''
        }
      }
      // 导出
      const exportTable = async () => {
        const hide = message.loading('正在加载中...', 0);
        var json = JSON.parse(JSON.stringify(search.value))
        delete json.page;
        delete json.page_num;
        let result = await awardLogsExport(json).then(res => res.data).catch(error => error)
        setTimeout(hide);
        if (iscode(result)) {
          // window.open(result.data.url)
          message.success('导出中,文件请在生成报表查看！')
        } else {
          message.error(result.message)
        }
      }
      return {
        ...toRefs(state),
        search,
        list,
        columns,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        onChange,
        activityVisible,
        activitySelect,
        productVisible,
        goodSelect,
        citychange,
        changIsAward,
        exportTable,
      };
    },
  };
</script>